// extracted by mini-css-extract-plugin
export default {"segments_container":"segments-page_segments_container__R-CIq"};